import React from "react";
import { Modal, Form, Row, Col, Card, Button, Select } from "antd";
import { EtapeModeleService } from "../../services/EtapeModeleService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import style from "./EtapeModeleCreateForm.module.scss";
import { EtapeService } from "../../services/EtapeService";
import CustomFormItem from "../utils/form/CustomFormItem";

const EtapeModeleCreateForm = ({
	visible,
	onCreate,
	onCancel,
	modele_id,
	etapeModeles,
}) => {
	const [form] = Form.useForm();
	const [creating, setCreating] = React.useState(false);
	const [validationErrors, setValidationErrors] = React.useState({});
	const [etapes, setEtapes] = React.useState([]);

	React.useEffect(() => {
		EtapeService.getInstance()
			.all()
			.then((response) => {
				setEtapes(response.data);
			});
	}, []);

	React.useEffect(() => {
		form.setFieldsValue(
			etapes.filter((etape) => etapeModeles.includes(etape.id))
		);
	}, [etapeModeles, form, etapes]);

	const handleSave = () => {
		setCreating(true);
		form
			.validateFields()
			.then((values) => {
				values.modele_id = modele_id;

				EtapeModeleService.getInstance()
					.create(values)
					.then((response) => {
						Toast.success(response.message);
						form.resetFields();
						onCreate(response.data);
					})
					.catch((error) => {
						const errors = error.response.data;
						if (errors.validation && Object.keys(errors?.errors).length) {
							setValidationErrors(errors.errors);
						} else {
							catchError(error);
						}
					})
					.finally(() => {
						setCreating(false);
						onCancel();
					});
			})
			.catch(() => {
				setCreating(false);
			});
	};

	return (
		<Modal
			width={"50%"}
			open={visible}
			onCancel={onCancel}
			title='Créer une nouvelle etape modele'
			footer={[
				<>
					<Row gutter={24}>
						<Col>
							<Button
								key='cancel'
								onClick={onCancel}
								className={style.ButtonNew}
							>
								Annuler
							</Button>
						</Col>
						<Col>
							<Button
								key='save-again'
								type='primary'
								loading={creating}
								onClick={() => handleSave()}
								className={style.ButtonNew}
							>
								Enregistrer
							</Button>
						</Col>
					</Row>
				</>,
			]}
		>
			<Card style={{ marginBottom: 5 }}>
				<Form
					layout='vertical'
					form={form}
					name='createEtapeModeleForm'
					initialValues={{}}
				>
					<Row gutter={24}>
						<Col xs={24} md={24} lg={24}>
							<CustomFormItem
								label='Etape'
								name='etapes'
								rules={[
									{
										required: true,
										message: "Veuillez selectionner les étapes",
									},
								]}
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Select
									size='large'
									mode='tags'
									allowClear
									placeholder='Selectionner des etapes'
									showSearch
									optionFilterProp='label'
									options={etapes.map((etape) => ({
										value: etape.nom,
										label: etape.nom,
									}))}
								/>
							</CustomFormItem>
						</Col>
					</Row>
				</Form>
			</Card>
		</Modal>
	);
};

export default EtapeModeleCreateForm;

EtapeModeleCreateForm.propTypes = {
	visible: PropTypes.bool,
	onCreate: PropTypes.func,
	onCancel: PropTypes.func,
	modele_id: PropTypes.number,
	etapeModeles: PropTypes.array,
};
